import { render, staticRenderFns } from "./WorkFlow.vue?vue&type=template&id=b5df1a62&scoped=true"
import script from "./WorkFlow.vue?vue&type=script&lang=js"
export * from "./WorkFlow.vue?vue&type=script&lang=js"
import style0 from "./WorkFlow.vue?vue&type=style&index=0&id=b5df1a62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5df1a62",
  null
  
)

export default component.exports